import React, { useCallback, useMemo } from "react";

import ColorPicker from "../../../../common/ColorPicker";
import { useComponentConfigContext } from "../common/ComponentConfigContext";
import { ConfigSection, Field } from "../common/ConfigPanel";

export default function DesignConfig() {
  const context = useComponentConfigContext();
  const {
    draftComponent: {
      properties: { theme_properties }
    }
  } = context.state;
  const { dispatch } = context;

  const themeProperties = useMemo(() => {
    return (
      theme_properties || {
        "background-color": undefined,
        "text-color": undefined
      }
    );
  }, [theme_properties]);

  const updateThemeProperties = useCallback(
    change => {
      dispatch({
        type: "UPDATE_COMPONENT_THEME_PROPERTIES",
        payload: {
          properties: {
            ...themeProperties,
            ...change
          }
        }
      });
    },
    [dispatch, themeProperties]
  );

  return (
    <ConfigSection title="Style">
      <Field>
        <label>Fill</label>
        <ColorPicker
          value={themeProperties["background-color"]}
          size="small"
          onChange={value => {
            updateThemeProperties({
              "background-color": value
            });
          }}
        />
      </Field>
      <Field>
        <label>Text color</label>
        <ColorPicker
          value={themeProperties["color"]}
          size="small"
          onChange={value => {
            updateThemeProperties({
              color: value
            });
          }}
        />
      </Field>
    </ConfigSection>
  );
}
